<template>
  <a-entity class="objects">
    <a-entity class="lights">
      <!-- world -->
      <!-- <a-entity data-v-4ac84d14="" light="color: #ffffff; castShadow: ${isMobile ? 'false' : 'true'}; shadowCameraNear: 0; shadowCameraTop: 15.27; shadowCameraRight: 15.74; shadowCameraLeft: -14.76; shadowCameraVisible: true; shadowMapHeight: 512.39; shadowCameraBottom: -10.28" position="22.83311 18.32489 -1.83645" visible="" class="Directional"></a-entity> -->
      <a-entity
        data-v-4ac84d14
        light="type: ambient; color: #ffffff; intensity: 0.7; groundColor: #854d00"
        position
        rotation
        visible
        class="Ambient"
      ></a-entity>
      <!-- point -->
      <a-entity
        data-v-4ac84d14=""
        :light="`type: point; color: #EEE; intensity: 0.5;  penumbra: 0.3; distance: 15`"
        position="-0.23947 2.67169 -11.21937"
        rotation="270 0 0"
        visible=""
        class="Point_1"
      >
      </a-entity>
      <!-- spots -->
      <a-entity
        data-v-4ac84d14
        :light="`type: spot; color: #ffffff; intensity: 0.4;  penumbra: 0.1; angle: 55`"
        position="3.34705 6.44272 0"
        rotation="270 0 0"
        class="Spot_1"
      ></a-entity>
      <a-entity
        data-v-4ac84d14
        :light="`type: spot; color: #ffffff; intensity: 0.5;  penumbra: 0.3; angle: 70`"
        position="-4.47301 5.906 -2.62251"
        rotation="-54.76960859435052 90.00021045914971 -90.00021045914971"
        class="Spot_2"
      ></a-entity>
      <a-entity
        data-v-4ac84d14
        :light="`type: spot; color: #ffffff; intensity: 0.3;  penumbra: 0.3; angle: 65`"
        position="15.55917 6.40947 -3.63254"
        rotation="-86.29088169347276 -90.0019293325351 90.0019293325351"
        class="Spot_3"
      ></a-entity>
      <a-entity
        data-v-4ac84d14
        :light="`type: spot; color: #ffffff; intensity: 0.3;  penumbra: 0.3; angle: 65`"
        position="11.45083 5.7882 3.09897"
        rotation="-57.28432035717971 -105.93302082614765 111.10224605381794"
        class="Spot_4"
      ></a-entity>
      <a-entity
        data-v-4ac84d14
        :light="`type: spot; color: #ffffff; intensity: 0.3;  penumbra: 0.3`"
        position="7.70065 4.94029 5.55079"
        rotation="-41.88206890847292 179.29396395690313 111.58926017967913"
        class="Spot_5"
      ></a-entity>
      <a-entity
        data-v-4ac84d14
        :light="`type: spot; color: #ffffff; intensity: 0.3;  penumbra: 0.3`"
        position="-0.16617 5.93161 5.55079"
        rotation="-40.6828682432641 164.22861169173325 122.1339754412668"
        class="Spot_6"
      ></a-entity>
      <a-entity
        data-v-4ac84d14
        :light="`type: spot; color: #ffffff; intensity: 0.3;  penumbra: 0.3; angle: 65; distance: 20`"
        position="9.52552 6.40947 -4.69917"
        rotation="-86.29088169347276 -41.83680524265758 90.0019293325351"
        class="Spot_7"
      ></a-entity>
      <a-entity
        data-v-4ac84d14
        :light="`type: spot; color: #ffffff; intensity: 0.4;  penumbra: 0.3`"
        position="-4.47301 5.906 5.46969"
        rotation="-54.76960859435052 90.00021045914971 -90.00021045914971"
        class="Spot_8"
      ></a-entity>
    </a-entity>

    <!-- Signs & LCD -->
    <a-gltf-model
      :scale="mainScale"
      src="\store\LCD_Blue.fbx.glb"
    ></a-gltf-model>
    <!-- <a-gltf-model
      :scale="mainScale"
      src="\store\LCD_Lines.fbx.glb"
    ></a-gltf-model> -->
    <!-- <a-gltf-model
      :scale="mainScale"
      src="\store\Oppo_Huwawi_Signs.fbx.glb"
    ></a-gltf-model> -->
    <a-gltf-model
      :scale="mainScale"
      src="\store\Apple_Display.fbx.glb"
    ></a-gltf-model>

    <!-- people -->
    <a-image
      position="-7.024 1.0 0.286"
      rotation="0 90 0"
      scale="2.25 2.25 2.25 "
      src="#person1"
      alpha-test="0.5"
    ></a-image>
    <a-image
      position="-6.6 1.38 -9.33"
      rotation="0 45 0"
      scale="2.5 2.5 2.5"
      src="#person2"
      alpha-test="0.5"
    ></a-image>
    <a-image
      position="-3.516  1.045 10.519"
      rotation="0 135 0"
      scale="2.25 2.25 2.25 "
      src="#person3"
      alpha-test="0.5"
    ></a-image>
    <a-image
      position="15.860 0.96 -3.835"
      rotation="0 105 0"
      scale="2 2 2"
      src="#person4"
      alpha-test="0.5"
    ></a-image>
    <a-image
      position="12.619 0.954 2.668"
      rotation="0 270 0"
      scale="2 2 2"
      src="#person5"
      alpha-test="0.5"
    ></a-image>
    <a-image
      position="3.482 0.955 -3.767"
      rotation="0 0 0"
      scale="2 2 2"
      src="#person6"
      alpha-test="0.5"
    ></a-image>

    <!-- Shadows -->

    <a-image
      scale="2.7 6.72 1"
      rotation="90 90 0"
      position="3.5 0.01 -3.21"
      src="#boxShadow"
      alpha-test="0.25"
    ></a-image>

    <a-image
      scale="2.7 2.7 1"
      rotation="90 90 0"
      position="10.97 0.01 1.89"
      src="#boxShadow"
      alpha-test="0.15"
    ></a-image>

    <a-image
      scale="2.7 2.7 1"
      rotation="90 90 0"
      position="10.97 0.01 4.84"
      src="#boxShadow"
      alpha-test="0.15"
    ></a-image>

    <a-image
      scale="2.2 2.2 1"
      rotation="90 90 0"
      position="11.7 0.01 -1.7"
      src="\textures\Circle_Shadow.png"
      alpha-test="0.2"
    ></a-image>
    <!-- eggs -->
    <a-image
      scale="0.9 0.9 0.9"
      rotation="90 90 0"
      position="-4.32 0.3 4"
      src="\textures\Circle_Shadow.png"
      alpha-test="0.05"
    ></a-image>

    <a-image
      scale="0.9 0.9 0.9"
      rotation="90 90 0"
      position="-5.43 0.3 6.52"
      src="\textures\Circle_Shadow.png"
      alpha-test="0.05"
    ></a-image>
    <!-- plants -->
    <a-image
      scale="0.5 0.5 1"
      rotation="90 90 0"
      position="-7.257 0.01 9.77"
      src="\textures\Circle_Shadow.png"
      alpha-test="0.05"
    ></a-image>

    <a-image
      scale="0.5 0.5 1"
      rotation="90 90 0"
      position="13.63 0.01 6"
      src="\textures\Circle_Shadow.png"
      alpha-test="0.05"
    ></a-image>

    <a-image
      scale="0.5 0.5 1"
      rotation="90 90 0"
      position="16 0.01 -1"
      src="\textures\Circle_Shadow.png"
      alpha-test="0.05"
    ></a-image>

    <a-image
      scale="1.5 1.5 1"
      position="2.247 1.332 -5"
      src="\textures\Globe_Ball_shadow_smaller.png"
      alpha-test="0.1"
    ></a-image>

    <a-image
      scale="2.22 2.22 1"
      position="4.317 1.672 -5"
      src="\textures\Globe_Text_shadow.png"
      alpha-test="0.1"
    ></a-image>

    <a-image
      scale="2 2 1"
      rotation="90 180 0"
      position="8.0 0.01 8.7"
      src="#shadowSofa"
      alpha-test="0.1"
    ></a-image>

    <a-image
      scale="2 2 1"
      rotation="90 0 0"
      position="5.8 0.01 8.7"
      src="#shadowSofa"
      alpha-test="0.1"
    ></a-image>

    <a-image
      scale="2 2 1"
      rotation="90 180 0"
      position="4.8 0.01 8.7"
      src="#shadowSofa"
      alpha-test="0.1"
    ></a-image>

    <a-image
      scale="2 2 1"
      rotation="90 180 0"
      position="2.184 0.01 8.7"
      src="#shadowSofa"
      alpha-test="0.1"
    ></a-image>

    <a-image
      scale="1.7 1.6 1"
      rotation="90 180 0"
      position="3.4 0.01 8.612"
      src="#boxShadow"
      alpha-test="0.1"
    ></a-image>

    <a-image
      scale="1.7 1.6 1"
      rotation="90 180 0"
      position="6.858 0.01 8.612"
      src="#boxShadow"
      alpha-test="0.1"
    ></a-image>

    <a-image
      scale="6.0 5.0 1"
      rotation="90 180 0"
      position="-5.1 0.06 5.5"
      src="#boxShadow"
      alpha-test="0.08"
    ></a-image>

    <!-- Shadows phonetables -->
    ‏
    <!-- left -->
    <a-image
      scale="3.2 2.6 2"
      rotation="90 180 0"
      position="-0.1 0.017 -0.950"
      src="#boxShadow"
      alpha-test="0.08"
    ></a-image>

    <a-image
      scale="3.2 2.6 2"
      rotation="90 180 0"
      position="-0.1 0.017 1.545"
      src="#boxShadow"
      alpha-test="0.08"
    ></a-image>

    <a-image
      scale="3.2 2.6 2"
      rotation="90 180 0"
      position="-0.1 0.017 4"
      src="#boxShadow"
      alpha-test="0.08"
    ></a-image>
    <!-- right -->
    <a-image
      scale="3.2 2.6 2"
      rotation="90 180 0"
      position="6.9 0.017 -0.950"
      src="#boxShadow"
      alpha-test="0.08"
    ></a-image>

    <a-image
      scale="3.2 2.6 2"
      rotation="90 180 0"
      position="6.9 0.017 1.545"
      src="#boxShadow"
      alpha-test="0.08"
    ></a-image>

    <a-image
      scale="3.2 2.6 2"
      rotation="90 180 0"
      position="6.9 0.017 4"
      src="#boxShadow"
      alpha-test="0.08"
    ></a-image>
    <!-- middle -->
    <a-image
      scale="3.2 2.6 2"
      rotation="90 90 0"
      position="3.5 0.017 0.85"
      src="#boxShadow"
      alpha-test="0.08"
    ></a-image>

    <a-image
      scale="3.2 2.6 2"
      rotation="90 90 0"
      position="3.5 0.017 2.2"
      src="#boxShadow"
      alpha-test="0.08"
    ></a-image>
    <!-- bottom -->
    <a-image
      scale="3.2 2.6 2"
      rotation="90 90 0"
      position="2 0.017 5.9"
      src="#boxShadow"
      alpha-test="0.08"
    ></a-image>

    <a-image
      scale="3.2 2.6 2"
      rotation="90 90 0"
      position="5 0.017 5.9"
      src="#boxShadow"
      alpha-test="0.08"
    ></a-image>

    <!-- Shadows computers -->
    <a-image
      scale="0.75 0.75 "
      rotation="270 0 0"
      position="3.5 0.98 -3"
      src="\textures\Compuer_Shadow.png"
      alpha-test="0.08"
    ></a-image>

    <a-image
      scale="0.75 0.75 "
      rotation="270 0 0"
      position="5.5 0.98 -3"
      src="\textures\Compuer_Shadow.png"
      alpha-test="0.08"
    ></a-image>

    <a-image
      scale="0.75 0.75 "
      rotation="270 0 0"
      position="1.5 0.98 -3"
      src="\textures\Compuer_Shadow.png"
      alpha-test="0.08"
    ></a-image>

    <!-- computers -->
    <!-- 2:32:55 -->
    <a-gltf-model
      :scale="mainScale"
      src="#computer"
      position="5.5 0.975 -3"
      class="computer"
    ></a-gltf-model>
    <a-gltf-model
      :scale="mainScale"
      src="#computer"
      position="3.5 0.975 -3"
      class="computer"
    ></a-gltf-model>
    <a-gltf-model
      data-v-4ac84d14
      scale="0.01 0.01 0.01"
      src="#computer"
      position="1.5 0.975 -3"
      class="computer"
      gltf-model="/store/Computer.fbx.glb"
    ></a-gltf-model>

    <!-- counter  -->
    <a-gltf-model
      data-v-4ac84d14
      scale="0.01 0.01 0.01"
      src="#counterGray"
      shadow
      gltf-model="/store/Gray_Counter.fbx.glb"
      position="0 -0.04 0"
    ></a-gltf-model>
    <a-gltf-model
      data-v-4ac84d14
      scale="0.01 0.01 0.01"
      src="#counterWood"
      gltf-model="/store/Counter_Wood.fbx.glb"
      position="0 -0.07 0"
    ></a-gltf-model>
    <a-gltf-model :scale="mainScale" src="#globeBall"></a-gltf-model>
    <a-gltf-model
      :scale="mainScale"
      src="#globeText"
      class="globe-text"
      @model-loaded="globeText"
    ></a-gltf-model
    >v

    <a-gltf-model
      :scale="mainScale"
      @model-loaded="glassBox"
      class="glass_box"
      src="/store/Glass_Wall_Box.fbx.glb"
      model-opacity="0.3"
    ></a-gltf-model>
    <a-gltf-model
      @model-loaded="glassWall"
      class="glass_wall"
      :scale="mainScale"
      shadow
      src="/store/Glass_Walls.fbx.glb"
    ></a-gltf-model>
    <a-gltf-model
      :scale="mainScale"
      src="\store\Glass_Wall_Box_2.fbx.glb"
    ></a-gltf-model>
    <a-gltf-model
      :scale="mainScale"
      src="/store/Hive_Deco.fbx.glb"
    ></a-gltf-model>
    <a-gltf-model
      :scale="mainScale"
      src="\store\Egg_Chair.fbx.glb"
    ></a-gltf-model>

    <!-- objects -->
    <a-gltf-model
      :scale="mainScale"
      position="0 0 0"
      src="/store/Phone_Boxes_3.fbx.glb"
    ></a-gltf-model>

    <!-- plants -->
    <a-gltf-model
      data-v-4ac84d14=""
      scale="0.01 0.01 0.01"
      position="-7.22378 0 9.759"
      src="\store\Plant.fbx.glb"
      gltf-model="\store\Plant.fbx.glb"
      rotation="0 45 0"
    ></a-gltf-model>
    <a-gltf-model
      data-v-4ac84d14=""
      scale="0.01 0.01 0.01"
      position="16.0415 0 -1.01166"
      src="\store\Plant.fbx.glb"
      gltf-model="\store\Plant.fbx.glb"
    ></a-gltf-model>
    <a-gltf-model
      data-v-4ac84d14=""
      scale="0.01 0.01 0.01"
      position="13.64019 0 6.04482"
      src="\store\Plant.fbx.glb"
      gltf-model="\store\Plant.fbx.glb"
      rotation="0 90 0"
    ></a-gltf-model>

    <!-- seating table -->
    <a-entity class="seating-table" position="11 0 5">
      <a-gltf-model
        :scale="mainScale"
        position="-0.4 0 0.8"
        rotation="0 270 0"
        src="#chairCoffeeTable"
      ></a-gltf-model>
      <a-gltf-model
        :scale="mainScale"
        position="0.6 0 0.8"
        rotation="0 270 0"
        src="#chairCoffeeTable"
      ></a-gltf-model>
      <a-gltf-model
        :scale="mainScale"
        shadow="cast:  false"
        position="0 0 0"
        rotation="0 90 0"
        src="#tableWhiteCoffee"
      ></a-gltf-model>
      <a-gltf-model
        :scale="mainScale"
        position="-0.4 0 -0.8"
        rotation="0 90 0"
        src="#chairCoffeeTable"
      ></a-gltf-model>
      <a-gltf-model
        :scale="mainScale"
        position="0.6 0 -0.8"
        rotation="0 90 0"
        src="#chairCoffeeTable"
      ></a-gltf-model>
    </a-entity>
    <a-entity class="seating-table" position="11 0 2">
      <a-gltf-model
        :scale="mainScale"
        position="-0.4 0 0.8"
        rotation="0 270 0"
        src="#chairCoffeeTable"
      ></a-gltf-model>
      <a-gltf-model
        :scale="mainScale"
        position="0.6 0 0.8"
        rotation="0 270 0"
        src="#chairCoffeeTable"
      ></a-gltf-model>
      <a-gltf-model
        :scale="mainScale"
        shadow="cast:  false"
        position="0 0 0"
        rotation="0 90 0"
        src="#tableWhiteCoffee"
      ></a-gltf-model>
      <a-gltf-model
        :scale="mainScale"
        position="-0.4 0 -0.8"
        rotation="0 90 0"
        src="#chairCoffeeTable"
      ></a-gltf-model>
      <a-gltf-model
        :scale="mainScale"
        position="0.6 0 -0.8"
        rotation="0 90 0"
        src="#chairCoffeeTable"
      ></a-gltf-model>
    </a-entity>

    <!-- <a-box position="0 2 0" scale="3 3 3" @model-loaded="boxTest" class="boxTest"></a-box> -->

    <!-- fat table -->
    <!-- <a-gltf-model
      :scale="mainScale"
      position="11 0 -2"
      src="/store/Chair_Leather.fbx.glb"
    ></a-gltf-model>
    <a-gltf-model
      :scale="mainScale"
      position="11.8 0 -1.2"
      src="/store/Chair_Leather.fbx.glb"
    ></a-gltf-model> -->
    <a-gltf-model
      :scale="mainScale"
      position="12 0 -2"
      src="/store/Table_circle_white_fat.fbx.glb"
    ></a-gltf-model>

    <!-- sofa set -->
    <a-gltf-model
      :scale="mainScale"
      position="8 0 8.5"
      src="/store/Sofa.fbx.glb"
    ></a-gltf-model>
    <a-gltf-model
      :scale="mainScale"
      position="6.858 -0.2 8.494"
      rotation="0 90 0"
      src="/store/Table_Sofa.fbx.glb"
    ></a-gltf-model>
    <a-gltf-model
      :scale="mainScale"
      position="5.8 0 8.5"
      rotation="0 180 0"
      src="/store/Sofa.fbx.glb"
    ></a-gltf-model>

    <a-gltf-model
      data-v-4ac84d14
      scale="0.01 0.01 0.01"
      position="2.22306 0 8.5"
      rotation="0 180 0"
      src="/store/Sofa.fbx.glb"
    ></a-gltf-model>
    <a-gltf-model
      data-v-4ac84d14
      scale="0.01 0.01 0.01"
      position="3.446 -0.2 8.494"
      rotation="0 90 0"
      src="/store/Table_Sofa.fbx.glb"
    ></a-gltf-model>
    <a-gltf-model
      data-v-4ac84d14
      scale="0.01 0.01 0.01"
      position="4.72906 0 8.5"
      src="/store/Sofa.fbx.glb"
    ></a-gltf-model>

    <!-- item tables -->
    <a-gltf-model
      :scale="mainScale"
      position="0 0 0"
      src="#itemTable"
      shadow
    ></a-gltf-model>
    <!-- <a-gltf-model
      :scale="mainScale"
      position="0 0 0"
      src="\store\Glass_Stand_Huawei.fbx.glb"
      shadow="receive:  false"
    ></a-gltf-model> -->

    <a-entity class="earphones">
      <a-gltf-model
        :scale="mainScale"
        position="-3.2 0.9 -1.6"
        src="#earphones"
        :earphones-color="`color: red`"
        shadow
      ></a-gltf-model>
      <a-gltf-model
        :scale="mainScale"
        position="-3.2 0.9 -0.5a"
        src="#earphones"
        :earphones-color="`color: blue`"
        shadow
      ></a-gltf-model>
      <a-gltf-model
        :scale="mainScale"
        position="-3.2 0.9 -4.1"
        src="#earphones"
        :earphones-color="`color: red`"
        shadow
      ></a-gltf-model>
      <a-gltf-model
        :scale="mainScale"
        position="-3.2 0.9 -5.2"
        src="#earphones"
        :earphones-color="`color: blue`"
        shadow
      ></a-gltf-model>
    </a-entity>

    <!-- <a-gltf-model :scale="mainScale" position="-6 0 0" rotation="0 90 0" src="#itemTable" shadow></a-gltf-model>
    <a-gltf-model :scale="mainScale" position="-6 0 -4" rotation="0 90 0" src="#itemTable" shadow></a-gltf-model>
    <a-gltf-model :scale="mainScale" position="-3.5 0 0" rotation="0 90 0" src="#itemTable" shadow></a-gltf-model>
    <a-gltf-model :scale="mainScale" position="-3.5 0 -4" rotation="0 90 0" src="#itemTable" shadow></a-gltf-model>-->

    <!-- structure -->
    <a-gltf-model
      data-v-4ac84d14
      scale="0.01 0.01 0.01"
      src="#walls"
      gltf-model="/store/Walls.fbx.glb"
      shadow
      position
    ></a-gltf-model>
    <a-gltf-model
      :scale="mainScale"
      shadow="cast: false"
      src="/store/White_Box_Floor.fbx.glb"
    ></a-gltf-model>
    <a-gltf-model src="/store/Wood_Wall.fbx.glb"></a-gltf-model>

    <a-gltf-model shadow src="/store/Wood_Wall_Small.fbx.glb"></a-gltf-model>

    <a-gltf-model
      :scale="mainScale"
      class="floorTest"
      @model-loaded="meshDetails"
      src="#floor"
      shadow
    ></a-gltf-model>
    <a-gltf-model
      data-v-4ac84d14
      scale="0.01 0.01 0.01"
      src="/store/Roof.fbx.glb"
      gltf-model="/store/Roof.fbx.glb"
      position
      shadow
    ></a-gltf-model>
    <a-gltf-model
      :scale="mainScale"
      class="Spotstest"
      @model-loaded="RoofSpots"
      src="/store/Roof_Lights.fbx.glb"
    ></a-gltf-model>

    <a-gltf-model :scale="mainScale" src="#frontGate"></a-gltf-model>
    <a-gltf-model :scale="mainScale" src="#outsideFloor"></a-gltf-model>
    <a-gltf-model src="#panorama"></a-gltf-model>

    <!-- borders- colliders -->
    <a-plane
      v-if="colliders"
      static-body
      visible="false"
      width="10"
      height="5"
      position="0 0 1"
      rotation="0 90 0"
    ></a-plane>
    <a-plane
      v-if="colliders"
      static-body
      visible="false"
      width="10"
      height="5"
      position="3 0 6"
      rotation="0 0 0"
    ></a-plane>
    <a-plane
      v-if="colliders"
      static-body
      visible="false"
      width="10"
      height="5"
      position="7 0 1"
      rotation="0 -90 0"
    ></a-plane>
    <a-plane
      v-if="colliders"
      class="samsung-collider"
      static-body
      visible="false"
      width="1"
      height="5"
      position="3.5 0 1.6"
      rotation="0 90 0"
    ></a-plane>
    <a-plane
      v-if="colliders"
      static-body
      visible="false"
      width="10"
      height="5"
      position="2 0 -4"
      rotation="0 0 0"
    ></a-plane>

    <!-- posters -->
    <!-- small -->
    <a-image
      class
      src="/poster_apple_small.png"
      position="8 1.5 1.5"
      height="0.6"
      width="1.1"
      rotation="0 -90 0"
    >
      <a-plane
        color="black"
        position="0 0 -0.01"
        width="1.15"
        height="0.65"
      ></a-plane>
      <a-cylinder
        color="black"
        position="0 -1 -0.05"
        height="1.5"
        radius="0.02"
      ></a-cylinder>
    </a-image>
    <a-image
      src="/poster_huawei_small.png"
      class
      position="-1 1.5 1.5"
      height="0.6"
      width="1.1"
      rotation="0 90 0"
    >
      <!-- src="/poster_huawei_small.png" -->
      <!-- <a-plane color="black" position="0 0 -0.01" width="1.15" height="0.65"></a-plane> -->
      <a-box
        color="black"
        position="0 0 -0.01"
        width="1.15"
        height="0.65"
        depth="0.01"
      ></a-box>

      <a-cylinder
        color="black"
        position="0 -1 -0.05"
        height="1.5"
        radius="0.02"
      ></a-cylinder>
    </a-image>
    <a-image
      class
      src="/poster_oppo_small.png"
      position="3.3 1.5 7"
      height="0.6"
      width="1.1"
      rotation="0 190 0"
    >
      <a-plane
        color="black"
        position="0 0 -0.01"
        width="1.15"
        height="0.65"
      ></a-plane>
      <a-cylinder
        color="black"
        position="0 -1 -0.05"
        height="1.5"
        radius="0.02"
      ></a-cylinder>
    </a-image>
    <a-image
      class
      src="/poster_samsung_small.png"
      position="4.6 1.5 1.6"
      height="0.6"
      width="1.1"
      rotation="0 -90 0"
    >
      <a-box
        color="black"
        position="0 0 -0.01"
        width="1.15"
        height="0.65"
        depth="0.01"
      ></a-box>
      <a-cylinder
        color="black"
        position="0 -1 -0.05"
        height="1.5"
        radius="0.02"
      ></a-cylinder>
    </a-image>

    <!-- big -->
    <a-image
      class
      src="/poster_samsung_big.jpg"
      position="-10 3 0.35"
      height="4"
      width="1.7"
      rotation="0 90 0"
    ></a-image>
    <a-image
      class
      src="/poster_oppo_big.jpg"
      position="-10 3 -1.6"
      height="4"
      width="1.7"
      rotation="0 90 0"
    ></a-image>
    <a-image
      class
      src="/poster_apple_big.jpg"
      position="-10 3 -3.55"
      height="4"
      width="1.7"
      rotation="0 90 0"
    ></a-image>
    <a-image
      class
      src="/poster_huawei_big.jpg"
      position="-10 3 -5.5"
      height="4"
      width="1.7"
      rotation="0 90 0"
    ></a-image>
  </a-entity>
</template>
<script>
/*eslint-disable */
// import * as THREE from 'three';
export default {
  name: "objects",
  props: ["mainScale", "colliders"],
  components: {},
  data: () => {
    return {
      isMobile: false,
    };
  },
  methods: {
    glassBox: function () {
      let box = document.querySelector(".glass_box");
      var tex = new THREE.ImageUtils.loadTexture(
        "/textures/Glass_Opacity_texture.png"
      );
      box.object3D.children[0].children[0].children[0].material.alphaMap = tex;

    },
    glassWall: function () {
      let walls = document.querySelector(".glass_wall");
    },
    boxTest: function (color, el) {
      // console.log(document.querySelector(".boxTest"));
    },
    earphonesColor: function (color, el) {
      console.log(el);
    },
    rayIntersect: function (ev) {
      this.rayDistance = ev.detail.getIntersection(ev.target).distance;
    },
    phoneHover: function (phn, index) {
      let phone = this.phones[index];
      phone.showTxt = !phone.showTxt;
      // console.log(this.tables);
    },
    log(str) {
      console.log("asdklask");
      console.log(str.replace(/ /g, "_"));
    },
    meshDetails: () => {
      var tex = new THREE.ImageUtils.loadTexture("/Normal_Blue_Floor_512.jpg");
      tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
      tex.repeat.set(2, 2);
      document.querySelector(
        ".floorTest"
      ).object3D.children[0].children[0].children[0].material.bumpMap = tex;
      document.querySelector(
        ".floorTest"
      ).object3D.children[0].children[0].children[0].material.color = {
        r: 0,
        g: 0.1,
        b: 0.3,
      };
      document.querySelector(
        ".floorTest"
      ).object3D.children[0].children[0].children[0].material.specular = {
        r: 0.8,
        g: 0.8,
        b: 0.8,
      };
      document.querySelector(
        ".floorTest"
      ).object3D.children[0].children[0].children[0].material.glossiness = 0.4;
    },
    globeText: () => {
      document.querySelector(
        ".globe-text"
      ).object3D.children[0].children[0].children[0].material.color = {
        r: 0.1,
        g: 0.2,
        b: 0.6,
      };
      document.querySelector(
        ".globe-text"
      ).object3D.children[0].children[0].children[0].material.specular = {
        r: 0.7,
        g: 0.5,
        b: 0.5,
      };
      document.querySelector(
        ".globe-text"
      ).object3D.children[0].children[0].children[0].material.opacity = 1;

    },
    RoofSpots: () => {
      document.querySelector(
        ".Spotstest"
      ).object3D.children[0].children[2].children[0].material.emissive = {
        r: 1,
        g: 1,
        b: 1,
      };
    },
  },
  mounted: function () {
    if (AFRAME.utils.device.isMobile()) {
      this.isMobile = true;
    }

  },
};
</script>
